import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../lib/components';
import {TimeZoneComponentStore} from '../TimeZoneComponentStore';

@observer
export class EditTimeZoneControls extends React.Component<{ store: TimeZoneComponentStore }> {
  render() {
    const store = this.props.store;

    if (store.editTimeZone === null)
      return null;

    const editTimeZone = store.editTimeZone;
    const isPending = editTimeZone.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeEdit}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Updating" state={editTimeZone.save} align="right"/>
    </>);
  }
}
